import { Component, OnInit, ViewChild } from "@angular/core";
// import { Settings, AppSettings } from "../../app.settings";
// import { AppService } from "../../app.service";
// import { Property, Pagination, Location } from "../../app.models";
// import { filter, map } from "rxjs/operators";
// import { Subscription } from "rxjs";
// import { MediaChange, MediaObserver } from "@angular/flex-layout";
// import { debounceTime, distinctUntilChanged } from "rxjs/operators";

//import { MortgagemagicPropertyService } from "../../services/MortgagemagicProperty.service";
// import { MortgagemagicProperty } from "src/app/models/MortgagemagicProperty.model";
// import { GoSourceProductRequest } from "src/app/models/GoSourceProductRequest.model";
import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { GoSourceLenderProductService } from 'src/app/services/GoSourceLenderProduct.service';
// import { GoSourceProductRequest } from './../../models/GoSourceProductRequest.model';
import DateUtil from "src/app/helper/Date.Util";
import StorageKeyName from "src/app/helper/StorageKeyName";
import UtilityHelper from "src/app/helper/UtilityHelper";

// new import { OwlCarouselOComponent } from 'ngx-owl-carousel-o';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { CarouselComponent } from 'ngx-owl-carousel-o';
@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  //@ViewChild('owlElement', { static: false }) owlElement: CarouselComponent;


  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    nav: false,
    navSpeed: 700,
    navText: ['<i class="fa fa-chevron-left"></i>', '<i class="fa fa-chevron-right"></i>'],
    responsive: {
      0: {
        items: 1
      },
      400: {
        items: 1
      },
      600: {
        items: 2
      },
      900: {
        items: 3
      }
    },
    // nav: true
  }
  // owlNext() {
  //   this.owlElement.next([200]);
  // }

  slidesStore = [
    {
      id: 1,
      img: '../../../assets/homepage-assets/image 2.svg',
      icon:'../../../assets/homepage-assets/download 1.svg',
      title:'Mortgage Magic',
      text:'Mortgage magic is an end-to-end platform designed to revolutionize the way mortgage intermediaries...',
      valuation: ' £200 M',
      sharePrice: 'N/A'
    },
    {
      id: 2,
      img: '../../../assets/homepage-assets/image 3.svg',
      icon:'../../../assets/homepage-assets/Frame 24030.svg',
      title:'Veracity Ventures Hub Ltd.',
      text:'Finance magic is an end-to-end platform designed to revolutionize the way mortgage intermediaries and...',
      valuation: 'N/A',
      sharePrice: 'N/A'
    },
    {
      id: 3,
      img: '../../../assets/homepage-assets/image 4.svg',
      icon:'../../../assets/homepage-assets/logo 3.svg',
      title:'Finance Magic',
      text:'Finance magic is an end-to-end platform designed to revolutionize the way mortgage intermediaries and...',
      valuation: 'N/A',
      sharePrice: 'N/A'
    },
    {
      id: 4,
      img: '../../../assets/homepage-assets/image 5.svg',
      icon:'../../../assets/homepage-assets/download 3.svg',
      title:'Gazeal',
      text:'Every year around 300,000 property sales collapse. We believe this is unfair.',
      valuation: 'N/A',
      sharePrice: 'N/A'
    },
    // {
    //   id: 5,
    //   img: '../../../assets/homepage-assets/item-5.svg',
    //   title:'VAUX Brewery',
    //   text:'With a rich history in Sunderland, Vaux are at the forefront of the emerging craft beer scene',
    //   valuation: '2.5M',
    //   sharePrice: '15.84'
    // },
  ]
  
  // Image section  profile
  public profiles = [
    {
      id: 1,
      name: 'Elena Rose',
      email: 'elena_rose@mail.com',
      phone: '+44 77188546221',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      imgUrl: "../../../assets/homepage-assets/imgProfile-bg.svg",
      
    },
    {
      id: 1,
      name: 'Elena Rose',
      email: 'elena_rose@mail.com',
      phone: '+44 77188546221',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      imgUrl: "../../../assets/homepage-assets/imgProfile-bg.svg",
      
    },
    
    {
      id: 1,
      name: 'Elena Rose',
      email: 'elena_rose@mail.com',
      phone: '+44 77188546221',
      text: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
      imgUrl: "../../../assets/homepage-assets/imgProfile-bg.svg",
      
    },
    
    
  ]

  public cardContainer = [
    {
      id: 1,
      title: 'Healthcare',
      totalUser: '68M',
      userProfile: 'Lives Under Care',
      imgUrl: "../../../assets/homepage-assets/home-icon-1.svg",
    },
    {
      id: 1,
      title: 'Social & Education',
      totalUser: '354M',
      userProfile: 'Monthly Active Users',
      imgUrl: "../../../assets/homepage-assets/home-icon-2.svg",
    },
    {
      id: 1,
      title: 'Housing & Transportation',
      totalUser: '78M',
      userProfile: 'Families Served',
      imgUrl: "../../../assets/homepage-assets/home-icon-3.svg",
    },
    {
      id: 1,
      title: 'Fintech & E-commerce',
      totalUser: '$157B',
      userProfile: 'Annual Transaction Volume',
      imgUrl: "../../../assets/homepage-assets/home-icon-4.svg",
    },
  ]
 

  public  _productType1: number = 1;
  public  _productType2: number = 3;

  // watcher: Subscription;
  // activeMediaQuery = "";

  // public slides: any[] = [];
  // public properties: any;
  // public propertie: any;
  // public viewType: string = "grid";
  // public viewCol: number = 25;
  // public count: number = 8;
  // public sort: string;
  // public searchFields: any;
  // public removedSearchField: string | null;
  // public pagination: Pagination = new Pagination(1, 8, null, 2, 0, 0);
  // public message: string | null;
  // public featuredProperties: Property[];
  // public locations: Location[];
  // public Length:number = 0;
  // public shortProperties: any;
  // public loddMore: number = 4;
  // public isloddMore: boolean = false;

  // public settings: Settings;
  // public _mortgagemagicPropertyService: MortgagemagicPropertyService;
  // public _goSourceProductRequest: GoSourceProductRequest;
  // public _goSourceLenderProductService: GoSourceLenderProductService;

  public _mortgageProductList: any = [];
  public _buyToLetProductList: any = [];


  public submitted = true;
  public _IsLoading1 = false;
  public _IsLoading2 = false;
  public _IsAllDataLoaded = false;

  // public _mortgagemagicPropertyList: MortgagemagicProperty[];

  constructor(
    private http: HttpClient,
    // public appSettings: AppSettings,
    // public appService: AppService,
    // public mediaObserver: MediaObserver,    
  ) {
    // this.settings = this.appSettings.settings;

    
    // this._financemagicContactService = financemagicContactService;

    // this.watcher = mediaObserver
    //   .asObservable()
    //   .pipe(
    //     filter((changes: MediaChange[]) => changes.length > 0),
    //     map((changes: MediaChange[]) => changes[0])
    //   )
    //   .subscribe((change: MediaChange) => {
    //     // console.log(change)
    //     if (change.mqAlias == "xs") {
    //       this.viewCol = 100;
    //     } else if (change.mqAlias == "sm") {
    //       this.viewCol = 50;
    //     } else if (change.mqAlias == "md") {
    //       this.viewCol = 33.3;
    //     } else {
    //       this.viewCol = 25;
    //     }
    //   });
  }
   currentSlide = 0;
  // transform: string = 'translateX(0)';

  // prevSlide() {
  //   if (this.currentSlide > 0) {
  //     this.currentSlide--;
  //   } else {
  //     this.currentSlide = this.slidesStore.length - 3;
  //   }
  //   this.updateTransform();
  // }

  // nextSlide() {
  //   if (this.currentSlide < this.slidesStore.length - 3) {
  //     this.currentSlide++;
  //   } else {
  //     this.currentSlide = 0;
  //   }
  //   this.updateTransform();
  // }

  // updateTransform() {
  //   this.transform = `translateX(-${this.currentSlide * 33.333}%)`;
  // }

  // ngOnInit() {
  //   //   this.getSlides();
  //   //   this.getLocations();
  //   //   // this.getProperties();
  //   //   //this.getFeaturedProperties();

  //   //  // this.getAllPropertyList();
  //   //    this.getAllGoSourceProductByDynamicPropertySearchList();

  //   // this.getAllCountryTestApi();
  //   // this.getTestmortgagemagicpropertyAPI();

  //   //this.getServerStatus();

  //   // this.Length = this.properties.length

  //   // this.initGoSOurceProductSearch();
  //   // this.getGoSourceProduct();
   
  // }

  
  // public initGoSOurceProductSearch() {
  //   this._mortgageProductList = [];
  //   this._buyToLetProductList = [];
  //   this.submitted = true;
  //   this._IsAllDataLoaded = false;

  //   this._goSourceProductRequest.TotalTermMonth = 240;
  //   this._goSourceProductRequest.PropertyValuationAmount = 200000;
  //   this._goSourceProductRequest.LoanAmount = 150000;
  //   this._goSourceProductRequest.DepositAmount = 50000;
  //   this._goSourceProductRequest.ProductTypeId = 1;

  //   this._goSourceProductRequest.LTVAmount = (this._goSourceProductRequest.LoanAmount / this._goSourceProductRequest.PropertyValuationAmount) * 100;


  //   this._goSourceProductRequest.PreferredMortgageTermYear = 20;
  //   this._goSourceProductRequest.PreferredMortgageTermMonth = 0;
  //   this._goSourceProductRequest.PaymentMethod = "Repayment";


  //   this._goSourceProductRequest.IsProductTypeFixed = true;
  //   this._goSourceProductRequest.IsProductTypeVariable = true;
  //   this._goSourceProductRequest.IsProductTypeDiscount = true;
  //   this._goSourceProductRequest.IsProductTypeTracker = true;

  //   this._goSourceProductRequest.Criteria = 1;
  //   this._goSourceProductRequest.Page = 0;
  //   this._goSourceProductRequest.Count = 5;
  //   this._goSourceProductRequest.ProductCategoryId = 0;
  //   this._goSourceProductRequest.OrderBy = '';
  //   this._goSourceProductRequest.InterestOnlyAmount = 0;


  // }

  // //#region Mortgage product search 



  // public getGoSourceProduct() {

  //   if (UtilityHelper.checkExpiration()) {
  //     var buytoletProductList = localStorage.getItem(StorageKeyName.KEY_BUY_TOLET_PRODUCT);
  //     var mortgageProductList = localStorage.getItem(StorageKeyName.KEY_MORTGAGE_PRODUCT);

  //     if (buytoletProductList != null && buytoletProductList.length > 0) {
  //       this._buyToLetProductList = JSON.parse(buytoletProductList);
  //     }
  //     else {

  //       if (mortgageProductList != null && mortgageProductList.length > 0) {
  //         this.getBuyToLetMortgageProductList(this._goSourceProductRequest);
  //       }
  //     }


  //     if (mortgageProductList != null && mortgageProductList.length > 0) {
  //       this._mortgageProductList = JSON.parse(mortgageProductList);
  //     }
  //     else {
  //       this.getMortgageProductList(this._goSourceProductRequest);
  //     }
  //   }
  //   else {
  //     this.getMortgageProductList(this._goSourceProductRequest);
  //   }

  // }

  // public getMortgageProductList(goSourceProductRequest: GoSourceProductRequest) {


  //   try {

  //     this._goSourceProductRequest.ProductTypeId = 1;

  //     if (this._IsLoading1 || this._IsAllDataLoaded) {
  //       return;
  //     }

  //     this._IsLoading1 = true;

  //     this._goSourceLenderProductService.GetProductListForCaseSourcingbyCaseRequirementsDataForMortgageByMobileApplication(goSourceProductRequest).subscribe({
  //       next: (responseData) => {
  //         console.log(responseData);

  //         this._IsLoading1 = false;
  //         if (responseData.Success && responseData.ResponseData != null && responseData.ResponseData.LenderProductList.length > 0) {

  //           if (responseData.ResponseData.LenderProductList.length < 5) {
  //             this._IsAllDataLoaded = true;
  //           }

  //           for (var k = 0; k < responseData.ResponseData.LenderProductList.length; k++) {
  //             this._mortgageProductList.push(responseData.ResponseData.LenderProductList[k]);
  //           }

  //           const mortgageProductJSON = JSON.stringify(this._mortgageProductList);
  //           localStorage.setItem(StorageKeyName.KEY_MORTGAGE_PRODUCT, mortgageProductJSON);

  //           //this._lenderProductList  = responseData.ResponseData.LenderProductList;
  //           //console.log(responseData.ResponseData);

  //           if (this._mortgageProductList.length > 30) {
  //             this._IsAllDataLoaded = true;
  //           }
  //         }
  //         else {
  //           this._IsAllDataLoaded = true;
  //         }

  //         this.getBuyToLetMortgageProductList(this._goSourceProductRequest);

  //       },
  //       error: (response) => {
  //         this._IsLoading1 = false;
  //         console.log(response);
  //         console.log(response.error);
  //       },
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }


  // //#endregion


  // //#region Buy to let product list 

  // public getBuyToLetMortgageProductList(goSourceProductRequest: GoSourceProductRequest) {


  //   try {

  //     this._goSourceProductRequest.ProductTypeId = 3;
  //     if (this._IsLoading2 || this._IsAllDataLoaded) {
  //       return;
  //     }

  //     this._IsLoading2 = true;

  //     this._goSourceLenderProductService.GetProductListForCaseSourcingbyCaseRequirementsDataForMortgageByMobileApplication(goSourceProductRequest).subscribe({
  //       next: (responseData) => {
  //         console.log(responseData);

  //         this._IsLoading2 = false;
  //         if (responseData.Success && responseData.ResponseData != null && responseData.ResponseData.LenderProductList.length > 0) {

  //           if (responseData.ResponseData.LenderProductList.length < 5) {
  //             this._IsAllDataLoaded = true;
  //           }

  //           for (var k = 0; k < responseData.ResponseData.LenderProductList.length; k++) {
  //             this._buyToLetProductList.push(responseData.ResponseData.LenderProductList[k]);
  //           }

  //           const btlProductJSON = JSON.stringify(this._mortgageProductList);
  //           localStorage.setItem(StorageKeyName.KEY_BUY_TOLET_PRODUCT, btlProductJSON);
  //           //this._lenderProductList  = responseData.ResponseData.LenderProductList;
  //           //console.log(responseData.ResponseData);

  //           if (this._buyToLetProductList.length > 30) {
  //             this._IsAllDataLoaded = true;
  //           }
  //         }
  //         else {
  //           this._IsAllDataLoaded = true;
  //         }

  //       },
  //       error: (response) => {
  //         this._IsLoading2 = false;
  //         console.log(response);
  //         console.log(response.error);
  //       },
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }



  //#endregion

  currentIndex = 0;
  transform = 'translateX(0)';
  interval: any;


  ngOnInit() {
    this.updateTransform();
    this.startAutoSlide();
  }

  ngOnDestroy() {
    this.clearAutoSlide();
  }

  next() {
    if (this.currentIndex + 3 < this.slidesStore.length) {
      this.currentIndex++;
    } else {
      this.currentIndex = 0; // Reset index to start from the first slide
    }
    this.updateTransform();
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    } else {
      this.currentIndex = this.slidesStore.length - 1; // Go to the last slide
    }
    this.updateTransform();
  }

  updateTransform() {
    const percentage = -this.currentIndex * 33.33;
    this.transform = `translateX(${percentage}%)`;
  }

  startAutoSlide() {
    this.interval = setInterval(() => {
      this.next(); // Automatically move to the next slide
    }, 3000); // Change slide every 3 seconds (adjust as needed)
  }

  clearAutoSlide() {
    if (this.interval) {
      clearInterval(this.interval); // Clear the interval to stop automatic sliding
    }
  }
}

